export * from '../services/storage.service';
export * from './manifest.component';
export * from './manifestchoice.component';


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/manifest/index.ts